<template>
  <Teleport to="body">
    <div
      class="pointer-events-none fixed left-4 top-20 z-[100] flex w-[calc(100%-32px)] justify-center px-4"
    >
      <FreeAlert
        ref="alertRef"
        class="pointer-events-auto max-w-[min(100%,420px)]"
        :duration="!isLimitError ? 2000 : 5000"
      >
        <template #icon>
          <InfoIcon v-if="isLimitError" />
          <CheckMarkIcon v-else />
        </template>
        <div class="min-w-0 text-left">
          <p
            class="text-text-neutral-primary text-center text-sm font-semibold"
          >
            {{ title }}
          </p>
          <p
            v-if="isLimitError"
            class="text-text-neutral-quaternary text-2xs mt-0.5 text-center font-normal leading-snug"
          >
            {{ description }}
          </p>
        </div>
      </FreeAlert>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { FreeAlert } from 'freedom-shared';

  import CheckMarkIcon from '@/assets/images/round-checkmark-icon.svg?component';
  import InfoIcon from '@/assets/images/info-red-icon.svg?component';

  import {
    FAVORITE_WATCHLIST_KIND,
    type FavoriteWatchlistKind,
  } from '../config';

  const { t } = useI18n();

  const kind = ref<FavoriteWatchlistKind>(FAVORITE_WATCHLIST_KIND.SEARCH);
  const isLimitError = ref(false);
  const alertRef = ref<InstanceType<typeof FreeAlert>>();

  const title = computed(() => {
    if (isLimitError.value) return t('favoritesWatchlistToast.limitTitle');
    return kind.value === FAVORITE_WATCHLIST_KIND.SEARCH
      ? t('favoritesWatchlistToast.searchTitle')
      : t('favoritesWatchlistToast.ticketTitle');
  });

  const description = computed(() =>
    isLimitError.value
      ? t('favoritesWatchlistToast.limitDescription')
      : t('favoritesWatchlistToast.description'),
  );

  const show = (k: FavoriteWatchlistKind) => {
    isLimitError.value = false;
    kind.value = k;
    alertRef.value?.show();
  };

  const showLimitError = () => {
    isLimitError.value = true;
    alertRef.value?.show();
  };

  defineExpose({ show, showLimitError });
</script>
